/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { StrandsPayload } from './StrandsPayload';
import {
    StrandsPayloadFromJSON,
    StrandsPayloadFromJSONTyped,
    StrandsPayloadToJSON,
} from './StrandsPayload';

/**
 * 
 * @export
 * @interface StrandsResponse
 */
export interface StrandsResponse {
    /**
     * 
     * @type {Array<Message>}
     * @memberof StrandsResponse
     */
    messages?: Array<Message>;
    /**
     * 
     * @type {StrandsPayload}
     * @memberof StrandsResponse
     */
    payload?: StrandsPayload;
}

/**
 * Check if a given object implements the StrandsResponse interface.
 */
export function instanceOfStrandsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StrandsResponseFromJSON(json: any): StrandsResponse {
    return StrandsResponseFromJSONTyped(json, false);
}

export function StrandsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrandsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messages': !exists(json, 'messages') ? undefined : ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'payload': !exists(json, 'payload') ? undefined : StrandsPayloadFromJSON(json['payload']),
    };
}

export function StrandsResponseToJSON(value?: StrandsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messages': value.messages === undefined ? undefined : ((value.messages as Array<any>).map(MessageToJSON)),
        'payload': StrandsPayloadToJSON(value.payload),
    };
}

